<div class="flex flex-col h-full" [class.overflow-y-auto]="isWeb">
  <!-- Contenedor del mapa: en nativo altura fija para evitar cálculo 0 en porcentaje -->
  <div class="map-container bg-transparent">
    @if(isWeb) {
    <div #map id="map" style="width: 100%; height: 100%"></div>
    } @else {
    <!-- Mapa para dispositivos móviles -->
    <capacitor-google-map #map id="map"></capacitor-google-map>
    }
  </div>

  <!-- Panel de información compacto y siempre visible -->
  <div
    class="bg-white flex flex-col px-5 py-3 items-center justify-center flex-shrink-0 border-t border-gray-200 h-[50%]"
  >
    <div class="w-full max-w-md">
      <div class="text-center mb-2" *ngIf="selectedLocation">
        <p class="font-medium text-sm">
          <span *ngIf="currentMode === 'edit-post'">{{
            "MAP.ARTICLE_LOCATION" | translate
          }}</span>
          <span *ngIf="currentMode === 'create-post'">{{
            "MAP.SELECTED_LOCATION" | translate
          }}</span>
          <span *ngIf="currentMode === 'filter'">{{
            "MAP.FILTER_LOCATION" | translate
          }}</span>
        </p>

        <!-- Sección con texto de dirección y spinner de carga -->
        <div class="flex flex-col items-center">
          <div *ngIf="isLoadingAddress" class="my-1">
            <ion-spinner name="crescent" color="primary"></ion-spinner>
            <p class="text-xs text-gray-500">
              {{ selectedAddress || ("MAP.GETTING_ADDRESS" | translate) }}
            </p>
          </div>

          <p
            *ngIf="!isLoadingAddress"
            class="text-xs text-gray-600 text-center px-2 line-clamp-2"
          >
            {{ selectedAddress || ("MAP.SELECT_POINT_ON_MAP" | translate) }}
          </p>
        </div>
      </div>

      <!-- Mensaje cuando no hay ubicación seleccionada -->
      <div class="text-center mb-2" *ngIf="!selectedLocation">
        <p class="text-sm text-gray-600">
          <span *ngIf="currentMode === 'create-post'">{{
            "MAP.TAP_MAP_TO_SELECT" | translate
          }}</span>
          <span *ngIf="currentMode === 'edit-post'">{{
            "MAP.SELECT_NEW_LOCATION" | translate
          }}</span>
          <span *ngIf="currentMode === 'filter'">{{
            "MAP.SELECT_LOCATION_TO_FILTER" | translate
          }}</span>
        </p>
      </div>

      <!-- Control de rango para modo filter - versión compacta -->
      <ng-container *ngIf="currentMode === 'filter' && showRangeSelector">
        <div class="w-full mb-2">
          <div class="flex justify-between w-full mb-1">
            <ion-label color="secondary" class="text-xs"
              >0 {{ "MAP.KM_UNIT" | translate }}</ion-label
            >
            <ion-label color="secondary" class="text-xs"
              >{{ range }} {{ "MAP.KM_UNIT" | translate }}</ion-label
            >
          </div>
          <div class="relative w-full px-2">
            <ion-range
              mode="md"
              max="200"
              [value]="range"
              (ionInput)="setRange($event)"
            ></ion-range>
          </div>
        </div>
      </ng-container>

      <!-- Botón aplicar con estado de carga -->
      <div class="w-full">
        <ion-button
          mode="ios"
          class="app-shadow w-full"
          size="small"
          (click)="setLocation()"
          [disabled]="!selectedLocation || isLoadingAddress || isProcessing"
        >
          <ion-spinner
            *ngIf="isProcessing"
            name="crescent"
            color="light"
          ></ion-spinner>
          <span *ngIf="!isProcessing">
            <span *ngIf="currentMode === 'filter'">{{
              "MAP.APPLY_LOCATION_FILTER" | translate
            }}</span>
            <span *ngIf="currentMode !== 'filter'">{{
              "MAP.SELECT_THIS_LOCATION" | translate
            }}</span>
          </span>
        </ion-button>
      </div>
    </div>
  </div>
</div>
